// @flow

import React from 'react'
import { useIntl } from 'gatsby-plugin-intl'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import classNames from 'classnames'
import { Container, Row, Col } from '../../../components/basic/Grid'
import ReadMoreAnimate from '../../../components/ReadMore/ReadMoreAnimate'
import baseStyles from './CaseFacts.scss'

type Props = {
  ...StyleProps,
  facts: Array<Object>
}

const CaseFacts = ({ styles, facts }: Props) => {
  const { formatMessage } = useIntl()

  return (
    <Container className={styles.root} fluid>
      <Row>
        {facts.map((item, i) => {
          return (
            <Col xs="12" md="4" className={styles.col} key={'caseFact' + i}>
              <span className={classNames(styles.icon, item.icon, styles['is-' + item.color])} />
              <span className={styles.name}>{formatMessage(item.title)}</span>
              <span className={styles.text}>
                <ReadMoreAnimate text={formatMessage(item.text)} height={270} />
              </span>
            </Col>
          )
        })}
      </Row>
    </Container>
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(CaseFacts)
